import { render, staticRenderFns } from "./Reclamacoes.vue?vue&type=template&id=f5cf731a&"
import script from "./Reclamacoes.vue?vue&type=script&lang=js&"
export * from "./Reclamacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports